import React, { Component } from 'react'
import { Layout } from '../../widgets'
import * as routes from '../../routes'
import { AdminBeatCell, FilterPicker } from '../components'
import { NavigationTab, PaginatedList } from '../../components'

const genreChoices = [
  { id: null, value: 'All' },
  { id: 'acoustic', value: 'Acoustic' },
  { id: 'ambient', value: 'Ambient' },
  { id: 'dance_edm', value: 'Dance & EDM' },
  { id: 'dance_hall', value: 'Dance Hall' },
  { id: 'latin', value: 'Latin' },
  { id: 'pop', value: 'Pop' },
  { id: 'r_b_soul', value: 'R&B & Soul' },
  { id: 'reggaeton', value: 'Reggaeton' },
  { id: 'rock', value: 'Rock' },
  { id: 'trap', value: 'Trap' },
]

class AdminBeats extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tab: 'Trending',
      genre: null,
    }
  }

  render = () => {
    const tabs = {
      'Trending': <PaginatedList
        key={'trending'}
        loadUrl={routes.adminBeatTrendingUrl}
        loadParams={{}}
        featuredUrl={routes.adminBeatFeaturedUrl}
        cell={AdminBeatCell}
        cellItemPropName={'beat'}
        datePicker={true}
        featureActionUpdateBehavior={'filter'}
      />,
      'New': <PaginatedList
        key={'recently_created'}
        loadUrl={routes.adminBeatNewUrl}
        loadParams={{}}
        featuredUrl={routes.adminBeatFeaturedUrl}
        cell={AdminBeatCell}
        cellItemPropName={'beat'}
        featureActionUpdateBehavior={'filter'}
      />,
      'Featured': <PaginatedList
        key={'recently_featured'}
        loadUrl={routes.adminBeatFeaturedUrl}
        loadParams={{}}
        featuredUrl={routes.adminBeatFeaturedUrl}
        cell={AdminBeatCell}
        cellItemPropName={'beat'}
        featureActionUpdateBehavior={'filter'}
      />,
      'Trending Feed': <>
        <FilterPicker.Genre
          onChange={(value) => this.setState({ genre: value[0] })}
          choices={genreChoices}
          singleChoice={true} defaultValues={[null]}
        />
        <PaginatedList
          key={this.state.genre ? `hot_genre_${this.state.genre}` : 'hot'}
          loadUrl={routes.adminBeatFeedUrl}
          loadParams={{'type': 'all_scored', 'genre': this.state.genre}}
          featuredUrl={routes.adminBeatFeaturedUrl}
          cell={AdminBeatCell}
          cellItemPropName={'beat'}
        />
      </>,
      'Featured Feed': <PaginatedList
        key={'featured'}
        loadUrl={routes.adminBeatFeedUrl}
        loadParams={{'type': 'featured_new'}}
        featuredUrl={routes.adminBeatFeaturedUrl}
        cell={AdminBeatCell}
        cellItemPropName={'beat'}
      />,
      'New Feed': <PaginatedList
        key={'new'}
        loadUrl={routes.adminBeatFeedUrl}
        loadParams={{'type': 'all_new'}}
        featuredUrl={routes.adminBeatFeaturedUrl}
        cell={AdminBeatCell}
        cellItemPropName={'beat'}
      />,
    }

    return (
      <div className='body-container'>
        <Layout>
          <Layout.Header>Beats</Layout.Header>
          <div className='moderator-content'>

            <div className='navigation-tabs'>
              {Object.keys(tabs).map((tab, i) =>
                <NavigationTab
                  key={i}
                  text={tab}
                  isActive={this.state.tab === tab}
                  onClick={() => {
                    if (this.state.tab !== tab) {
                      this.setState({ tab: tab })
                    }
                  }}
                />
              )}
            </div>

            {tabs[this.state.tab]}

          </div>
        </Layout>
      </div>
    )
  }
}

export default AdminBeats
